module.exports = __webpack_public_path__ + "img/1_025.af2b4fcc.jpg";